//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { IExperiencePreviewRequest, IExperiencePreviewResponse, IExperiencesResponse } from '@apis/experiences/experiencesApiModels';
import GalleryContainerId from '@galleries/models/GalleryContainerId';
import ExperienceContainerId from '@models/ExperienceContainerId';
import { gatewayFetch } from '@utils/sessionFetch';

function gatewayExperiencesFetch(endpoint: string, init?: RequestInit): Promise<Response> {
  return gatewayFetch('experience_gateway', `/api/v1/experiences${endpoint}`, init);
}

export async function getExperiences(): Promise<IExperiencesResponse> {
  const res = await gatewayExperiencesFetch('');
  return await res.json();
}

export async function getExperiencePreview(
  containerId: ExperienceContainerId | GalleryContainerId,
  options: IExperiencePreviewRequest
  ): Promise<IExperiencePreviewResponse> {
  const res = await gatewayExperiencesFetch(`/${containerId}/preview`, {
    method: 'POST',
    body: JSON.stringify(options),
  });

  return await res.json();
}
